// API Configuration for connecting to backend services
export const apiConfig = {
  // Base URL for all API endpoints
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
  
  // API endpoints
  endpoints: {
    chatLogs: '/api/chatlogs',
    translateLogs: '/api/translatelogs',
    queryLogs: '/api/querylogs',
    chatDashboard: '/api/chatlogs/dashboard',
    chatAnalytics: '/api/chatlogs/analytics',
    translateDashboard: '/api/translatelogs/dashboard',
    translateAnalytics: '/api/translatelogs/analytics',
    queryDashboard: '/api/querylogs/dashboard',
    queryAnalytics: '/api/querylogs/analytics'
  },
  
  // Request configuration
  requestConfig: {
    timeout: 10000, // 10 seconds
    cacheDuration: 5000, // 5 seconds
    retryAttempts: 3,
    retryDelay: 1000
  },
  
  // Get full URL for an endpoint
  getUrl: (endpoint) => `${apiConfig.baseUrl}${endpoint}`,
  
  // Check if backend is accessible
  checkBackendHealth: async () => {
    try {
      const response = await fetch(`${apiConfig.baseUrl}/api/chatlogs/dashboard`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      return response.ok;
    } catch (error) {
      console.error('Backend health check failed:', error);
      return false;
    }
  }
};

export default apiConfig;
